import { createApiEffect } from '@/features/api/common/create-api-effect'
import { LoadingCourseApplications } from '@/features/api/learning/types'

export const getCourseApplicationsFx = createApiEffect<number, LoadingCourseApplications>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/ticket-app/course-ticket/${id}/`,
  }),
})
